import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import { forwardRef } from 'react';
import defaultStyles from './styles/Select.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';

const OptGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    label,
    theme,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  return /*#__PURE__*/jsx("li", {
    ref: ref,
    className: styles.option_group_title,
    ...omit(rest, ['_key', 'children', 'isSelectOptGroup']),
    children: label
  });
});
OptGroup.defaultProps = {
  isSelectOptGroup: true
};
OptGroup.displayName = 'OptGroup';

export { OptGroup };
